const GET_ORDER_BY_ID = 'GET_ORDER_BY_ID';
const SET_ORDER_BY_ID = 'SET_ORDER_BY_ID';

const GET_CART_COUNT = 'GET_CART_COUNT';
const SET_CART_COUNT = 'SET_CART_COUNT';

const GET_CART_ORDERS = 'GET_CART_ORDERS';
const SET_CART_ORDERS = 'SET_CART_ORDERS';

const GET_DELETE_CART_ORDER = "GET_DELETE_CART_ORDER";
const SET_DELETE_CART_ORDER = "SET_DELETE_CART_ORDER";

export
{
    GET_ORDER_BY_ID,
    SET_ORDER_BY_ID,
    SET_CART_COUNT,
    GET_CART_COUNT,
    SET_CART_ORDERS,
    GET_CART_ORDERS,
    GET_DELETE_CART_ORDER,
    SET_DELETE_CART_ORDER
};
